import { createClient } from '../util/supabase/component'
import { type QueryFunctionContext, useQuery } from '@tanstack/react-query'
import { sortSpecies } from '../util/helpers'

const queryFn = async (_: QueryFunctionContext<string[]>) => {
  const supabase = createClient()
  const { data, error } = await supabase
    .from('viability_constants')
    .select(
      '*, species(id,genus,epithet,infraspecies_rank,infraspecies_epithet)',
    )

  if (error) throw new Error(error.message)
  if (!data) return

  const refIds = new Set(
    data.map((item) => item.reference_id).filter(Boolean) as number[],
  )
  const { data: refs } = await supabase
    .from('references')
    .select('*')
    .in('id', Array.from(refIds))

  const refsMap = Object.fromEntries(
    refs ? refs.map((ref) => [ref.id, ref]) : [],
  )
  // interpolate references
  const newData = data.map((d) => {
    return { ...d, reference: d.reference_id ? refsMap[d.reference_id] : null }
  })
  return newData.sort((a, b) => sortSpecies(a.species, b.species))
}

export const useViabilityConstants = () => {
  const { data } = useQuery({
    queryKey: ['viability_constants'],
    queryFn,
    refetchOnMount: false,
  })

  return data
}
